/**
 * Client service for Hospital Compliance Starters (A9 Licences Integration).
 * R39 C5.a5 (plan docs/plans/sector-operations.md §2 SO-P252, H§5).
 * Wraps callables via callable(); components never import firebase/*.
 */

import { callable } from './callable'

export interface AddHospitalComplianceStartersInput {
  workspaceId: string
  includeImaging?: boolean
  opId?: string
}

export async function addHospitalComplianceStarters(
  input: AddHospitalComplianceStartersInput,
): Promise<{ success: true; createdKeys: string[]; skippedKeys: string[]; replayed?: boolean }> {
  return callable<
    AddHospitalComplianceStartersInput,
    { success: true; createdKeys: string[]; skippedKeys: string[]; replayed?: boolean }
  >('addHospitalComplianceStarters', input)
}
